import type { PiletApi } from '@chess/platform-web';
import { VERDICT_API, ruleVerdict } from '@chess/api-verdict';

// The verdict provider: the rule-based composer of `@chess/api-verdict`,
// registered as the `verdict` API. Readers: the latest-game card (the whole
// game), the stage sections' result cards (each stage) and the game strip
// (the stage that decided each game).
export function setup(app: PiletApi) {
  app.registerApi(VERDICT_API, ruleVerdict);
}
